import { Component, Renderer2, ViewChild, ElementRef, Input } from "@angular/core";
import { MessageBoxComponent } from "../message-box-modal.component";

@Component({
    selector: 'my-scrollable-list-message-box-modal',
    templateUrl: 'scrollable-list-message-box-modal.component.html',
    styleUrls: ['scrollable-list-message-box-modal.component.scss']
})
export class ScrollableListMessageBoxModal extends MessageBoxComponent {
    @ViewChild('scrollContainer', {static: false}) private scrollContainer: ElementRef;

    @Input() itemList: string[] = [];

    constructor(protected renderer: Renderer2) {
        super();
        this.buttonText = "OK";
        this.hideCancelButton = true;
    }

    show() {
        super.show();
    }

    hide() {
        if (this.scrollContainer) {
            this.renderer.setProperty(this.scrollContainer.nativeElement, 'scrollTop', 0);
        }

        super.hide();
    }
}